import { createUseStyles } from "react-jss";
import { ITheme } from "../../../store/slices/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    padding: `${theme.spacing.space16}px ${theme.spacing.space12}px`,
    background: theme.colors.Background4,
    borderRadius: theme.radius.medium,
    gap: theme.spacing.space16,
  },
  logo: {
    width: "60px",
    height: "60px",
    flexShrink: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    aspectRatio: "1/1",
  },
  header: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.space8,
    flex: 1,
    alignItems: "flex-start",
  },
  body: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing.space8,
    alignSelf: "stretch",
  },
  title:{
    lineHeight: "28px !important",
  },
  billingInfo: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
    gap: theme.spacing.space4,
    flex: "1 0 0",
  },
  unsubscribeButton: {
    padding: `${theme.spacing.space8}px ${theme.spacing.space16}px !important`,
    borderRadius: theme.spacing.space2,

    display: "flex",
    height: 36,
    justifyContent: "center",
    alignItems: "center",
    gap: theme.spacing.space8,
    alignSelf: "stretch",
  },
}));
